export default __webpack_public_path__ + "2494cc10f187bb4387e2b4b39b315a24.png";